import React from "react";
import { TiArrowLeftOutline } from "react-icons/ti";
import { Link } from "react-router-dom";
import Icon1 from "../../images/9.jpg";
import Icon2 from "../../images/8.jpg";
import Icon3 from "../../images/13.jpg";
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
  Icon,
} from "./SigninElements";

const Services = () => {
  return (
    <ServicesContainer id="services">
      <Link to="/">
        <Icon>
          <TiArrowLeftOutline />
        </Icon>
      </Link>
      <ServicesH1>Jestem Krystian</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={Icon1} />
          <ServicesH2>Mam niecałe 5 lat</ServicesH2>
          <ServicesP>chodzę do przedszkola.</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>Lubię rysować</ServicesH2>
          <ServicesP>.. i bawić się z dziećmi.</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon3} />
          <ServicesH2>Kocham Dinozaury</ServicesH2>
          <ServicesP>znam ich nazwy na pamięć!</ServicesP>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
